<template>
  <div>
    <div class="card mat10">
      <div class="flex-s-s" style="position: relative;">
        <img :src="detail.photo" class="img" />
        <div style="margin-left:20px">
          <div class="title">{{detail.exhibitionHallName}}</div>
          <ul class="key-value">
            <li v-for="item in messageList">
              <div class="key">{{item.key}}：</div>
              <div class="value">{{item.value}}</div>
            </li>
          </ul>
          <img src="@images/detailEnd.png" class="status" v-show="detail.isFinished==1" />
        </div>
      </div>
      <!-- <div class="fontcolor-grey mat20"> 活动说明：</div> -->
      <div class="mat20" style="line-height:30px" v-html="detail.description"> </div>
      <div class="flex-s-c detail-tag">
        <i class="iconfont icon-pinglun1-copy"></i>
        <div class="text">发布评论</div>
        <div class="gery-sm">文明上网理性发言，请遵守评论服务协议</div>
      </div>
      <div class="comment-box">
        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="textarea" maxlength="100" show-word-limit>
        </el-input>
        <el-button type="primary" class="mat20" @click="submitComment">发布</el-button>
      </div>

      <div class="flex-s-c detail-tag border">
        <i class="iconfont icon-pinglun1"></i>
        <div class="text">全部评论</div>
        <div class="gery-sm" v-if="total<100">{{total}}</div>
        <div class="gery-sm" v-else>99+</div>
      </div>
      <div class="comment">
        <div class="item" v-for="item in commentList">
          <div class="flex-sb-c">
            <div class="flex-s-c">
              <img class="photo" :src="item.photo||defaultPhoto" />
              <div class="name">{{item.userName}}</div>
            </div>
            <template v-if="item.volunteerId == userMess.id">
              <span style="color:red;cursor: pointer;" @click="deleteComment(item)">删除</span>
            </template>

          </div>

          <div style="margin-left: 80px">
            <div class="content">{{item.content}}</div>
            <div class="time">{{item.commentTime}}</div>
          </div>

        </div>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      messageList: [],
      commentList: [],
      textarea: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      detail: "",
      defaultPhoto: require('@images/photo-none.jpg')
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user.user
    },
  },
  watch: {},
  methods: {
    submitComment() {
      if (this.textarea == '') {
        this.$message.warning('请填写评论内容后在提交！');
      } else {
        let params = {
          content: this.textarea,
          exhibitionHallId: this.$route.params.id,
          volunteerId: this.userMess.id
        }
        this.$api.sendComment(params).then(res => {
          // console.log(res)
          if (res.code == 1) {
            this.$message.success(res.message);
            this.getList()
            this.textarea = ""
          } else {
            this.$message.error(res.message);
          }
        })
      }
    },
    getDetail() {
      this.$api.getHallDetail({ id: this.$route.params.id }).then(res => {
        // console.log(res)
        this.detail = res.data
        this.messageList = [
          { key: "展厅类型", value: res.data.exhibitionTypeName },
          { key: "展期", value: res.data.exhibitionPeriodName },
          { key: "展览期限", value: res.data.exhibitionPeriodType },
          { key: "楼层", value: res.data.floorName },
        ]
      })
    },
    //删除评论
    deleteComment(item) {
      this.$api.delComment({ commentId: item.commentId }).then(res => {
        if (res.code == 0) { this.$message.error(res.message) }
        else { this.$message.success(res.message); this.getList() }
      })
    },
    getList() {
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        id: this.$route.params.id

      }
      this.$api.getHallComment(params).then(res => {
        // console.log(res)
        this.commentList = res.data.rows
        this.total = res.data.total
      })
      // console.log(params)
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1
      this.getList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
      // console.log(`当前页: ${val}`);
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDetail()
    this.getList()
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.img {
  width: 500px;
  height: 312.5px;
}
.title {
  font-size: 22px;
}
.status {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 40px;
  right: 10px;
}

.detail-tag {
  padding: 20px 0;
  color: #007083;
  i {
    font-size: 24px;
    margin-right: 8px;
  }
  .text {
    font-weight: bold;
    font-size: 20px;
    margin-right: 8px;
  }
  .gery-sm {
    color: @font-grey;
    font-size: 14px;
  }
}
.detail-tag.border {
  border-bottom: 1px solid #c0c0c0;
}
.comment-box {
  position: relative;
  width: 800px;
  text-align: right;
}
.comment {
  .item {
    padding: 20px 0;
    border-bottom: 1px solid #c0c0c0;
    .photo {
      width: 60px;
      height: 60px;
      border-radius: 30px;
      margin-right: 20px;
    }
    .name {
      margin-top: 10px;
      color: #394565;
    }
    .time {
      margin-top: 20px;
      font-size: 14px;
      color: @font-grey;
    }
  }
}
</style>
